export const BookingErrors = {
  ClaimAlreadyConfirmed: 'RD004',
  TimeSlotTaken: 'RD001',
  ThirdPartyCommunication: 'RD013',
  InvalidDate: 'INVALID_DATE',
  UnknownError: 'UNKNOWN_ERROR',
  RetryError: 'RETRY_ERROR',
};
